import ImpuritiesForDrug from "./ImpuritiesForDrug";

export default ImpuritiesForDrug;